import { Buffer } from 'buffer'

import { isBrowser } from './index'

export function capitalizeFirstLetter(str: string) {
  if (str.length > 0) return str[0].toUpperCase() + str.slice(1)

  return str
}

export const checkIsAlphaNumeric = (str: string) => {
  const reg = /^[0-9a-zA-Z]+$/
  return reg.test(str)
}

/**
 * utf8_to_b64('✓ à la mode') => "4pyTIMOgIGxhIG1vZGU="
 */
export function utf8_to_b64(str: string) {
  return window.btoa(unescape(encodeURIComponent(str)))
}

/**
 * b64_to_utf8('4pyTIMOgIGxhIG1vZGU=') => "✓ à la mode"
 */
export function b64_to_utf8(str: string) {
  if (isBrowser()) {
    return unescape(window.atob(str))
  }

  const buff = Buffer.from(str, 'base64')
  return buff.toString()
}
